import { MESSAGES } from '../../../../../../common/Messages';

// Dynamic-form layout for the panel under the WMD0110 grid. FormField looks the layout up by this id
// and falls back to DefaultShipmentItemsLayout when none has been saved.
export const LAYOUT_ID = '498CB09A-4E6F-42A8-9D4C-302B451D182A';
export const LAYOUT_NAME = 'WMDefaultShipmentItemDetailsForm';

const TABLE = 'WMTRANSACTIONDETAIL';

export const FIELD = {
    LotDescription1: 'LotDescription1',
    LotAvailable: 'LotAvailable',
    Comment: 'Comment',
    LotMethod: 'LotMethod',
    SubLotMethod: 'SubLotMethod',
    LocationMethod: 'LocationMethod',
};

// The two group boxes of uWMD0110.dfm (grpBottomLeft / grpBottomRight).
//
// - Lot Information follows the focused grid row. Description and Available are read-only, as in
//   Delphi; Comment is editable (edtMemo has no ReadOnly) and is written to the new detail line.
// - Profile Methods shows how the stage change will allocate lot, sub-lot and location - MANUAL or
//   AUTO, read-only. Delphi has no caption on that box; the group needs one to render as a fieldset.
//
// isLabelChanged: true so Fields.js uses the label as given rather than a localization lookup.
export const DefaultShipmentItemsLayout = [
    {
        groupId: 1,
        label: MESSAGES.DEFAULT_SHIPMENT_ITEMS_LOT_INFORMATION,
        fields: [
            {
                name: FIELD.LotDescription1,
                tableName: TABLE,
                label: MESSAGES.DEFAULT_SHIPMENT_ITEMS_LOT_DESCRIPTION,
                type: 'text',
                readOnly: true,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.LotAvailable,
                tableName: TABLE,
                label: MESSAGES.DEFAULT_SHIPMENT_ITEMS_LOT_AVAILABLE,
                type: 'number',
                // Delphi's DisplayFormat ",0.00".
                format: '#,##0.00',
                readOnly: true,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.Comment,
                tableName: TABLE,
                label: MESSAGES.DEFAULT_SHIPMENT_ITEMS_COMMENT,
                type: 'textarea',
                visible: true,
                isLabelChanged: true,
            },
        ],
    },
    {
        groupId: 2,
        label: MESSAGES.DEFAULT_SHIPMENT_ITEMS_PROFILE_METHODS,
        fields: [
            {
                name: FIELD.LotMethod,
                tableName: TABLE,
                label: MESSAGES.DEFAULT_SHIPMENT_ITEMS_METHOD_LOT,
                type: 'text',
                readOnly: true,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.SubLotMethod,
                tableName: TABLE,
                label: MESSAGES.DEFAULT_SHIPMENT_ITEMS_METHOD_SUBLOT,
                type: 'text',
                readOnly: true,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.LocationMethod,
                tableName: TABLE,
                label: MESSAGES.DEFAULT_SHIPMENT_ITEMS_METHOD_LOCATION,
                type: 'text',
                readOnly: true,
                visible: true,
                isLabelChanged: true,
            },
        ],
    },
];
